export const MAX_UPLOAD_SIZE_MB = 500

export const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024

export const ACCEPTED_UPLOAD_TYPES = "audio/*,audio/aac,audio/mpeg,audio/ogg,audio/wav,audio/webm"

export const IN_FLIGHT_UPLOAD_STATUSES = ["pending", "uploading", "processing"]
